import { render } from "./BoardDetailMainContents.vue?vue&type=template&id=76c6de1d&scoped=true"
import script from "./BoardDetailMainContents.vue?vue&type=script&lang=js"
export * from "./BoardDetailMainContents.vue?vue&type=script&lang=js"

import "./BoardDetailMainContents.vue?vue&type=style&index=0&id=76c6de1d&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-76c6de1d"

export default script